import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { of, OperatorFunction, pipe } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapRetrieve } from '../common/rest.operators';
import { PeriodType } from '../widget/date-range.widget.model';

import {
    CoverageDataDto,
    CoverageDataDtoTransformer,
} from './coverage.coaching-insight.model';

// TODO revise maybe add this to rest.operators
function catchErrorLogRet<T, R = T>(ret?: any): OperatorFunction<T, R> {
    return pipe(
        catchError((err) => {
            console.log(err);
            return of(ret);
        }),
    );
}

@Injectable()
export class CoverageCoachingInsightService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieve<T>(
        project: (
            value: T,
            index: number,
        ) => {
            performerId: number;
            periodTypeId: PeriodType;
            periodDate: Date;
            rangeTypeId: PeriodType;
            periodStart: Date;
            periodEnd: Date;
        },
    ): OperatorFunction<T, CoverageDataDto> {
        return pipe(
            switchMap((value, index) => {
                const args = project(value, index);
                const params = new HttpParams()
                    .set('periodTypeId', args.periodTypeId.toString())
                    .set('periodDate', args.periodDate.toJSON())
                    .set('rangeTypeId', args.rangeTypeId.toString())
                    .set('periodStart', args.periodStart.toJSON())
                    .set('periodEnd', args.periodEnd.toJSON());
                return this._http.get(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/coverage/${args.performerId}`,
                    { params },
                );
            }),
            mapRetrieve(new CoverageDataDtoTransformer()),
            catchErrorLogRet(null),
        );
    }
}
